"use client";
import { r as e, t } from "./registration-BkPgmtZ2.js";
import { t as n } from "./tokens-DBlg30G8.js";
//#region src/openers/neonSlam/tokens.ts
var r = n, i = t(() => import("./NeonSlamOpener-CK1WwF-8.js"), r);
function a() {
	e("neon_slam", i);
}
//#endregion
export { a as n, r, i as t };

//# sourceMappingURL=neonSlam-Cs7KV0j3.js.map